'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Predicate2 = require('../abstract/Predicate');

var _Predicate3 = _interopRequireDefault(_Predicate2);

var _descriptorValue = require('../util/descriptorValue');

var _operators = require('../operators');

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommitDatePredicate = function (_Predicate) {
    (0, _inherits3.default)(CommitDatePredicate, _Predicate);

    function CommitDatePredicate() {
        (0, _classCallCheck3.default)(this, CommitDatePredicate);
        return (0, _possibleConstructorReturn3.default)(this, (CommitDatePredicate.__proto__ || (0, _getPrototypeOf2.default)(CommitDatePredicate)).apply(this, arguments));
    }

    (0, _createClass3.default)(CommitDatePredicate, [{
        key: 'convertValueToDate',
        value: function convertValueToDate() {
            var dataType = 'datetime';
            var value = this.value;


            return (0, _descriptorValue.treatValue)({ value: value, dataType: dataType });
        }
    }, {
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            return { commitDate: (0, _operators.getOperatorQueryFragment)(this.operator, this.convertValueToDate(), 'datetime') };
        }
    }, {
        key: 'operator',
        get: function get() {
            return this.data.operator;
        },
        set: function set(value) {
            this.data.operator = value;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.data.value;
        },
        set: function set(value) {
            this.data.value = value;
        }
    }]);
    return CommitDatePredicate;
}(_Predicate3.default);

CommitDatePredicate.defaultData = {
    operator: '$lte',
    value: Date.now()
};
CommitDatePredicate.dataType = 'datetime';
CommitDatePredicate.displayName = 'Date Committed';

_QueryNodeRegistry2.default.register(CommitDatePredicate);
exports.default = CommitDatePredicate;